import type { ReactNode } from 'react';

export type NavClassification = 'production' | 'preview' | 'demo-only';

export interface NavItemConfig {
  name: string;
  path: string;
  classification: NavClassification;
  /** Path used inside the demo sandbox (defaults to /demo + prod path). */
  demoPath?: string;
}

export interface NavSectionConfig {
  name: string;
  items: NavItemConfig[];
}

/** Production sidebar — tenant-backed or preview modules only. */
export const PRODUCTION_NAV: NavSectionConfig[] = [
  {
    name: 'Core',
    items: [
      { name: 'Dashboard', path: '/dashboard', classification: 'production' },
      { name: 'Dockets', path: '/dockets', classification: 'production' },
      { name: 'Dispatch', path: '/dispatch', classification: 'production' },
      { name: 'Tracking', path: '/tracking', classification: 'production' },
      { name: 'Carriers', path: '/carriers', classification: 'production' },
      { name: 'Billing', path: '/billing', classification: 'production' },
      { name: 'Analytics', path: '/analytics', classification: 'production' },
      { name: 'Reports', path: '/reports', classification: 'production' },
      { name: 'Commercial Analytics', path: '/reports/commercial', classification: 'production' },
      { name: 'Customer master', path: '/settings/customers', classification: 'production' },
      { name: 'Vendor master', path: '/settings/vendors', classification: 'production' },
      { name: 'Contract Master', path: '/settings/rate-master', classification: 'production' },
      { name: 'MDR queue', path: '/planning/requisitions', classification: 'production' },
      { name: 'Vendor quotes', path: '/planning/auctions', classification: 'production' },
      { name: 'Approval inbox', path: '/planning/approvals', classification: 'production' },
    ],
  },
  {
    name: 'Transportation',
    items: [
      { name: 'Fleet', path: '/fleet', classification: 'production' },
      { name: 'Route Planning', path: '/route-planning', classification: 'production' },
    ],
  },
];

/** Demo sandbox sidebar — sales evaluation only (FEATURE_DEMO_MODE).
 * Unfinished warehouse/logistics mock modules are intentionally omitted from nav;
 * their routes render ModuleUnderDevelopment instead of fake operational UI.
 */
export const DEMO_NAV: NavSectionConfig[] = [
  {
    name: 'Demo overview',
    items: [{ name: 'Demo home', path: '/demo', classification: 'demo-only' }],
  },
  {
    name: 'Transportation',
    items: [
      { name: 'Dashboard', path: '/demo/dashboard', classification: 'demo-only' },
      { name: 'Dockets', path: '/demo/dockets', classification: 'demo-only' },
      { name: 'Tracking', path: '/demo/tracking', classification: 'demo-only' },
      { name: 'Fleet', path: '/demo/fleet', classification: 'demo-only' },
      { name: 'Routes', path: '/demo/routes', classification: 'demo-only' },
      { name: 'Route Planning', path: '/demo/route-planning', classification: 'demo-only' },
      { name: 'Analytics', path: '/demo/analytics', classification: 'demo-only' },
    ],
  },
];

export function classificationBadge(classification: NavClassification): string | null {
  if (classification === 'preview') return 'Preview';
  if (classification === 'demo-only') return 'Demo';
  return null;
}
